import React, { useEffect } from "react";
import "./codes-integration.css";
import { integrationData } from "./store/integration-data";

const CodesIntegration = ({ handleChangeOption, selected_option }) => {

	useEffect(() => {
		if (selected_option !== "codigos_integracao") {
			handleChangeOption("codigos_integracao");
		}
	}, [ handleChangeOption, selected_option ]);

	const renderTabela = (titulo, dados, colunas) => {
		return (
			<div className="table-container">
				<div className="table-header">
					<h3>{ titulo }</h3>
				</div>
				<table className="codes-table">
					<thead>
					<tr>
						{ colunas.map((col, index) => (
							<th key={ index } className={ col.className }>{ col.nome }</th>
						)) }
					</tr>
					</thead>
					<tbody>
					{ dados.map((item, index) => (
						<tr key={ index }>
							{ colunas.map((col, colIndex) => (
								<td key={ colIndex } className={ col.className }>
									{ item[col.campo] }
								</td>
							)) }
						</tr>
					)) }
					</tbody>
				</table>
			</div>
		);
	};

	return (
		<div className="row mt-3 codes-integration-container">
			<div className="tables-grid">
				<div className="table-wrapper">
					{ renderTabela(
						"AR",
						integrationData.tabelaAR,
						[
							{ nome: "Código", campo: "codigo", className: "text-center" },
							{ nome: "Descrição", campo: "descricao", className: "text-left" }
						]
					) }
				</div>

				<div className="table-wrapper">
					{ renderTabela(
						"COLORAÇÃO",
						integrationData.tabelaColoracao,
						[
							{ nome: "Código", campo: "codigo", className: "text-center" },
							{ nome: "Descrição", campo: "descricao", className: "text-left" }
						]
					) }
				</div>

				<div className="table-wrapper">
					{ renderTabela(
						"COR DA COLORAÇÃO",
						integrationData.tabelaCorColoracao,
						[ { nome: "Código", campo: "codigo", className: "text-center" } ]
					) }
				</div>

				<div className="table-wrapper">
					{ renderTabela(
						"HC",
						integrationData.tabelaHC,
						[
							{ nome: "Código", campo: "codigo", className: "text-center" },
							{ nome: "Descrição", campo: "descricao", className: "text-left" }
						]
					) }
				</div>

				<div className="table-wrapper">
					{ renderTabela(
						"CORTE / MONTAGEM",
						integrationData.tabelaCorte,
						[
							{ nome: "Código", campo: "codigo", className: "text-center" },
							{ nome: "Descrição", campo: "descricao", className: "text-left" }
						]
					) }
				</div>

				<div className="table-wrapper">
					{ renderTabela(
						"TIPO DE ARMAÇÃO",
						integrationData.tabelaTipoArmacao,
						[
							{ nome: "Código", campo: "codigo", className: "text-center" },
							{ nome: "Descrição", campo: "descricao", className: "text-left" }
						]
					) }
				</div>
			</div>

			<div className="frame-model-section">
				<div className="table-container">
					<div className="table-header">
						<h3>MODELO DE ARMAÇÃO</h3>
					</div>
					<div className="frame-model-content">
						<img
							src='/image/product/model_frame.png'
							alt="Modelos de Armação"
							className="frame-model-img"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CodesIntegration;